<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:zipFlag="zipFlag"
		:pagingFlag="pagingFlag"
		:exportUrl="exportUrl"
		:exportByServerFlag="exportByServerFlag"
		:getFiltersParams="getFiltersParams"
		:reportFormUrl="reportFormUrl"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'>
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/OrderPayDetail.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapBest.vue'
import FiltersBox from '@/components/reportform/OrderPayDetail/FiltersBox.vue'
export default {
	name: 'OrderPayDetail',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			zipFlag: false, // 是否压缩
			pagingFlag: false, // 是否真分页
			exportByServerFlag: true, // 是否后端导出
			reportid: 'REPORT_DDCY_000001',
			exportUrl: 'orderDiffInAmountExport',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/orderDiffInAmount`,
			orderMenu: orderMenu,
			reportName: 'OrderPayDetail'
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
		// console.log(cols,'1')
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
